const selectionTypeConstants = {
    ATOM: 'Atom',
    GROUP: 'Group',
    RESIDUE: 'Residue',
    CHAIN: 'Chain',
  };
  
  export default selectionTypeConstants;